import React, { useEffect, useRef, useState } from 'react';
import lottie from 'lottie-web';
import HomeAnimation from './Animation.json';

const Animation = () => {
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 769);

  const anime = useRef(null);

  // using refs to ensure the load logic works
  const screenRef = useRef(isSmallScreen);
  screenRef.current = isSmallScreen;

  useEffect(() => {
    // listen for changes in window width for hide/show logic
    window.addEventListener('resize', checkScreenSize);

    return () => {
      window.removeEventListener('resize', checkScreenSize);
    };
  }, []);

  const checkScreenSize = () => {
    screenRef.current = window.innerWidth < 769;
    setIsSmallScreen(screenRef.current);
  };

  useEffect(() => {
    lottie.loadAnimation({
      container: anime.current,
      renderer: 'svg',
      loop: true,
      autoplay: true,
      animationData: HomeAnimation,
    });
    return () => lottie.stop();
  }, []);
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        marginTop: '5rem',
        width: '100%',
      }}
    >
      <div
        style={{
          height: 150,
          transform: isSmallScreen ? 'scale(2.5)' : 'scale(4)',
        }}
        ref={anime}
      ></div>
      <p style={{ marginTop: '6rem', color: 'white', fontSize: '1.5rem' }}>
        Loading your RegulationCity...
      </p>
    </div>
  );
};

export default Animation;
